import { createElementBlock as e, openBlock as o, createElementVNode as c } from "vue";
import r from "./index289.js";
const l = {}, a = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function n(s, t, m, p, f, i) {
  return o(), e("svg", a, t[0] || (t[0] = [
    c("path", {
      fill: "currentColor",
      d: "M13.714 20.207a.75.75 0 1 1 0 1.5h-3.428a.75.75 0 0 1 0-1.5h3.428ZM12 3.921c3.374 0 6.107 2.762 6.107 6.165v2.711c0 .069.038.13.094.159l.539.272a2.76 2.76 0 0 1 1.51 2.464c0 1.522-1.223 2.758-2.736 2.758H6.486c-1.513 0-2.736-1.236-2.736-2.758 0-1.041.583-1.996 1.51-2.466l.538-.27a.176.176 0 0 0 .095-.159v-2.711C5.893 6.683 8.626 3.92 12 3.92Zm0 1.5c-2.542 0-4.607 2.087-4.607 4.665v2.711c0 .632-.354 1.21-.918 1.497l-.538.271c-.42.213-.687.65-.687 1.127 0 .697.555 1.258 1.236 1.258h11.028c.68 0 1.236-.561 1.236-1.258a1.26 1.26 0 0 0-.686-1.125l-.542-.274a1.68 1.68 0 0 1-.915-1.496v-2.711c0-2.578-2.065-4.665-4.607-4.665Zm4.66-3.57a9.41 9.41 0 0 1 3.494 3.539.75.75 0 1 1-1.308.735 7.91 7.91 0 0 0-2.935-2.975.75.75 0 0 1 .75-1.3Zm-8.296.274a.75.75 0 0 1-.275 1.025 7.91 7.91 0 0 0-2.935 2.975.75.75 0 1 1-1.308-.735A9.41 9.41 0 0 1 7.34 1.85a.75.75 0 0 1 1.025.275Z"
    }, null, -1)
  ]));
}
const v = /* @__PURE__ */ r(l, [["render", n]]);
export {
  v as default
};
